import React from 'react';
import styles from './formrow.module.css';

interface FormRowProps {
  children: React.ReactNode[];
  className?: string;
  gap?: string;
}

const FormRow: React.FC<FormRowProps> = ({ children, className, gap }) => (
  <div className={`${styles.formRow} ${className}`} style={{ gap }}>
    {React.Children.map(children, (child) => (
      <div className={styles.formItem}>{child}</div>
    ))}
  </div>
);

FormRow.defaultProps = {
  className: '',
  gap: '10px',
};

export default FormRow;
